<template>
  <div>
    <button class="btn btn-info" v-on:click="getLocation">
      Solicitar ubicación
    </button>
    <p id="myPos"></p>
  </div>
</template>

<script>
export default {
    data: function(){
        return {
            latitud: Number,
            longitud: Number
        }
    },
  methods: {
    getLocation() {
        const html = document.querySelector("#myPos");

      if (navigator.geolocation) {
    
        navigator.geolocation.getCurrentPosition(location => {
              html.innerHTML = `Latitud: ${location.coords.latitude}, Longitud: ${location.coords.longitude}`;  
        });
        
      } else {
        html.innerHTML = "Geolocation is not supported by this browser.";
      }
    },
  },
};
</script>